import { useTranslation } from "react-i18next";
import { memo, useCallback } from "react";
import {
  TIntegrationRuleParamForm,
  integrationRuleParamSchema,
} from "./integrationRuleParamSchema";
import { FormContainer, Treturn, useFetch } from "@4uhub/lib4uhub";
import { IIntegrationRuleParamProps } from "./models";
import {
  createIntegrationRuleParam,
  getIntegrationRuleParamById,
  updateIntegrationRuleParamById,
} from "../../../../../../../services/integrationRuleParam.service";
import { IntegrationRuleParamFields } from "./IntegrationRuleParamFields";

const translationPath = "page.4uBus.integrationRule.integrationRuleParam.";

export const IntegrationRuleParam = memo(
  ({
    id,
    busIntegrationRuleId,
    busAutomationCode,
    onBackButton,
  }: IIntegrationRuleParamProps) => {
    const { t } = useTranslation();

    const { sendRequest: save, loading: sLoading } = useFetch(
      createIntegrationRuleParam,
    );

    const { sendRequest: update, loading: uLoading } = useFetch(
      updateIntegrationRuleParamById,
    );

    const { sendRequest: get, loading: gLoading } = useFetch(
      getIntegrationRuleParamById,
    );

    const saveHandler = (v: TIntegrationRuleParamForm) =>
      save({
        ...v,
        _4uBusIntegrationRuleId: busIntegrationRuleId ?? "",
        _4uBusAutomationParamId: v.uBusAutomationParam!.id,
      });

    const updateHandler = (v: TIntegrationRuleParamForm, id: string) =>
      update({
        item: {
          ...v,
          _4uBusIntegrationRuleId: busIntegrationRuleId ?? "",
          _4uBusAutomationParamId: v.uBusAutomationParam!.id,
        },
        id: id,
      });

    const getHandler = useCallback(
      async (id: string): Promise<Treturn<TIntegrationRuleParamForm>> => {
        const { data, success } = await get(id);
        if (data && success) {
          const newData: TIntegrationRuleParamForm = {
            ...data,
            uBusAutomationParam: data._4uBusAutomationParam,
          };
          return { data: newData, success: true };
        }

        return { data, success };
      },
      [get],
    );

    const loading = sLoading || uLoading || gLoading;

    return (
      <FormContainer<TIntegrationRuleParamForm>
        saveFunction={saveHandler}
        updateFunction={updateHandler}
        getFunction={getHandler}
        loading={loading}
        title={t(translationPath + "integration_rule_param")}
        schema={integrationRuleParamSchema}
        subtitle={t(translationPath + "new_integration_rule_param")}
        backButtonOnClick={onBackButton}
        redirectOnSave={false}
        onSuccess={onBackButton}
        isModalForm={true}
        propId={id}
        formActionsOnBottom={false}
        fields={() => (
          <IntegrationRuleParamFields busAutomationCode={busAutomationCode} />
        )}
      />
    );
  },
);
